import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import Icon from '../AppIcon';

const Breadcrumbs = () => {
  const location = useLocation();
  
  const pathMap = {
    '/dashboard-overview': 'Dashboard',
    '/vin-consultation': 'VIN Consultation',
    '/history-and-audit-trail': 'History & Audit Trail',
    '/user-administration': 'User Administration',
    '/system-configuration': 'System Configuration',
    '/login-and-authentication': 'Login'
  };

  const generateBreadcrumbs = () => {
    const pathSegments = location?.pathname?.split('/')?.filter(Boolean);
    const breadcrumbs = [];

    // Always start with Dashboard as home
    breadcrumbs?.push({
      label: 'Dashboard',
      path: '/dashboard-overview',
      isHome: true
    });

    // Add current page if it's not dashboard
    if (location?.pathname !== '/dashboard-overview' && location?.pathname !== '/') {
      const currentPageLabel = pathMap?.[location?.pathname] || 'Page';
      breadcrumbs?.push({
        label: currentPageLabel,
        path: location?.pathname,
        isCurrent: true
      });
    }

    return breadcrumbs;
  };

  const breadcrumbs = generateBreadcrumbs();

  // Don't show breadcrumbs on login page
  if (location?.pathname === '/login-and-authentication') {
    return null;
  }

  return (
    <nav className="flex items-center space-x-2 text-sm text-muted-foreground mb-6" aria-label="Breadcrumb">
      {breadcrumbs?.map((crumb, index) => (
        <div key={crumb?.path} className="flex items-center space-x-2">
          {index > 0 && (
            <Icon name="ChevronRight" size={14} className="text-muted-foreground" />
          )}
          
          {crumb?.isHome && (
            <Icon name="Home" size={14} className="text-muted-foreground" />
          )}
          
          {crumb?.isCurrent ? (
            <span className="font-medium text-foreground" aria-current="page">
              {crumb?.label}
            </span>
          ) : (
            <Link
              to={crumb?.path}
              className="hover:text-foreground transition-smooth"
            >
              {crumb?.label}
            </Link>
          )}
        </div>
      ))}
    </nav>
  );
};

export default Breadcrumbs;